import { useCallback, useContext } from "react";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { IUpdateVehicleParams } from "../domain";
import { apiServiceContext } from "../../api-service-context";
import { EntityType } from "../query-keys";

export const useUpdateVehicle = (options?: UseMutationOptions<any, any, IUpdateVehicleParams>) => {
  const { vehicleApiService } = useContext(apiServiceContext);
  const queryClient = useQueryClient();

  const mutationFn = useCallback(
    (payload: IUpdateVehicleParams) =>
      vehicleApiService.createCancellableRequest((cancelToken) =>
        vehicleApiService.updateVehicle(payload, cancelToken)
      ),
    [vehicleApiService]
  );

  const mutation = useMutation<any, any, IUpdateVehicleParams>(mutationFn, {
    ...options,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries(EntityType.USER_VEHICLE);
      options?.onSuccess?.(...args);
    },
  });

  return mutation;
};
